import { Alert } from 'antd';
import styled from 'styled-components';

import { theme } from '../ui/themes/default';

export const StyledAlert = styled(Alert)`
  border: none;
  background-color: ${theme.white};
  box-shadow: ${theme.boxShadow};
  padding: 12px 16px;
  margin-bottom: 24px;
`;

export const StyledAlertActions = styled.div`
  display: flex;

  .ant-btn:first-child {
    margin-right: 12px;
  }
`;
